import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { promise } from 'protractor';
import { resolve } from 'dns';

@Injectable({
  providedIn: 'root'
})
export class GeneralrevService {

  constructor(private fs: AngularFirestore, private storage: AngularFireStorage) { }

  getReview () {
    return this.fs.collection('generalreviews').valueChanges()
  }
  addReview ( name:string,
              message:string,
              rating:number,
              email:string,) {
                return new Promise( (resolve, reject)=> {
                  this.fs.collection('generalreviews').add({
                  name,
                  message,
                  rating,
                  email
                }).then(()=>resolve())
              })

  }

  addReviewWithPic(
              name:string,
              message:string,
              rating:number,
              email:string,
              photoUrl:File)
      {
      return new Promise((resolve, reject)=>{      
              
        let ref = this.storage.ref('generalreviews/' + photoUrl.name)
        ref.put(photoUrl).then( ()=> {
        ref.getDownloadURL().subscribe(photoUrl => {

        this.fs.collection('generalreviews').add({
          name,
          message,
          rating,
          email,
          photoUrl
        }).then(()=>resolve())

      })
    })
  }
)}

}
